// extracted by mini-css-extract-plugin
module.exports = {"days":"Days_days__2f1js"};